import { render, staticRenderFns } from "./SelectCoursesAlignedTable.vue?vue&type=template&id=b356ee9c&scoped=true&lang=pug&"
import script from "./SelectCoursesAlignedTable.vue?vue&type=script&lang=ts&"
export * from "./SelectCoursesAlignedTable.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCoursesAlignedTable.vue?vue&type=style&index=0&id=b356ee9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b356ee9c",
  null
  
)

export default component.exports